"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class WindowManager {
    constructor() {
        this.dialogList = [];
    }
    /**
     * When a dialog is shown, add it to the focus list
     */
    register(dialog) {
        this.dialogList.push(dialog);
        // hide page scrollbars
        if (this.dialogList.length === 1) {
            document.body.classList.add('dr-dialog__page-body');
        }
    }
    /**
     * When a dialog is hidden, remove it from the focus list
     */
    unregister(dialog) {
        const index = this.dialogList.indexOf(dialog);
        if (index > -1) {
            this.dialogList.splice(index, 1);
        }
        // restore page scrollbars
        if (this.dialogList.length === 0) {
            document.body.classList.remove('dr-dialog__page-body');
        }
    }
    /**
     * Check if the given dialog is the top most dialog
     */
    hasFocus(dialog) {
        if (this.dialogList.length === 0) {
            return false;
        }
        // check if the given dialog is last in the list
        return this.dialogList[this.dialogList.length - 1] === dialog;
    }
}
WindowManager.default = new WindowManager();
WindowManager.zIndex = 20000;
exports.default = WindowManager;
//# sourceMappingURL=WindowManager.js.map